import React, { useState } from "react";
import "../styles/CandidateCreate.scss";
import Select, { components } from "react-select";
import { useNavigate } from "react-router-dom";
import { Country, State, City } from "country-state-city";
import { createCandidate, getAllSkills,getAllEducationQualifications} from "../services/api";
import Swal from "sweetalert2";

const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      <label>{props.label}</label>
    </components.Option>
  );
};


function CreateCandidate() {
  const [resumeName, setResumeName] = useState("");
  const [error, setError] = useState("");
  const [skillsOptions, setSkillsOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [degreeOptions, setDegreeOptions] = useState([]);
  const [genderOptions] = useState([
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Other", value: "Other" },
    { label: "Prefer not to say", value: "Prefer not to say" },
  ]);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    alternate_email: "",
    phone: "",
    gender: "",
    dob: "",
    jobTitle: "",
    experience: "",
    relevant_exp: "",
    location: [],
    current_location: "",
    present_ctc: "",
    expected_cdc: "",
    designation: "",
    current_company: "",
    education_qualification: "",
    qualification_level: "",
    notice_period: "",
    any_offers_in_hand: "",
    willing_to_relocate: "",
    communication_skills_rating: 0,
    status: "New",
    skills: [],
    resume: null,
    linkedin: "",
    portfolio: "",
    notes: "",
  });
  const isFresher = form.experience !== "" && Number(form.experience) === 0;

  // Function to get Indian cities
  const getIndianCities = () => {
    try {
      // Get India country code
      const india = Country.getCountryByCode("IN");
      if (!india) return [];

      // Get all states of India
      const indianStates = State.getStatesOfCountry("IN");
      if (!indianStates || indianStates.length === 0) return [];

      // Get cities from all states
      const extraCities = ["Bhuwaneshwar","Gurugram"]; 
      const removeCities = ["Bangalore Urban", "Bangalore Rural", "Ghandhi Nagar","Lucknow District"];

       const removeSet = new Set(
           [...extraCities, ...removeCities].map(city => city.toLowerCase())
              );

            const existingCities = new Set();
             let allCities = [];

             indianStates.forEach((state) => {
             const cities = City.getCitiesOfState("IN", state.isoCode);

              if (!cities || cities.length === 0) return;

             cities.forEach((city) => {
             const name = city?.name?.trim();
              const key = name?.toLowerCase();

               if (
                   name &&
                   key &&
                   !existingCities.has(key) &&
                   !removeSet.has(key)
                     ) {
                   existingCities.add(key);

                   allCities.push({
                   value: name,
                   label: name,
                      });
                   }
                 });
              });


            allCities.push({
                value: "Remote",
                label: "Remote",
                     });


             allCities.sort((a, b) => a.label.localeCompare(b.label));

           return allCities;
               } catch (error) {
                       console.error("Error fetching Indian cities:", error);
                       return [];
                       }
                    };

  // Fetch skills and Locations from API on component mount
  React.useEffect(() => {
    const fetchSkills = async () => {
      try {
        const response = await getAllSkills();
        if (
          response &&
          response.result_code === 200 &&
          Array.isArray(response.result_info)
        ) {
          const skills = response.result_info.map((skill) => ({
            value: skill.skill_name || skill.name || skill,
            label: skill.skill_name || skill.name || skill,
          }));
          setSkillsOptions(skills);
        }
      } catch (error) {
        console.error("Error fetching skills:", error);
      }
    };

    // Fetch Indian cities
    const indianCities = getIndianCities();
    setLocationOptions(indianCities);

    fetchSkills();
  }, []);

 React.useEffect(() => {
    const fetchEducationQualifications = async () => {
      try {
        const response = await getAllEducationQualifications();
        if (
          response &&
          response.result_code === 200 &&
          Array.isArray(response.result_info)
        ) {
          
          const degrees = response.result_info.map((item) => ({
            value: item.degree,
            label: item.degree,
            qualification_level: item.qualification_level,
          }));
           setDegreeOptions(degrees);
        }
      } catch (error) {
        console.error("Error fetching education options:", error);
      }
    };
    fetchEducationQualifications();
  }, []);


  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      const file = files[0];
      const maxSize = 10 * 1024 * 1024; // 10 MB
      const allowedFormats = ["pdf", "doc", "docx"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      // Validate file format
      if (!allowedFormats.includes(fileExtension)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid File Format",
          text: "Only PDF, DOC, and DOCX files are allowed.",
          confirmButtonColor: "#0078b9",
        });
        e.target.value = "";
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        Swal.fire({
          icon: "warning",
          title: "File Too Large",
          text: "Please upload a file smaller than 10 MB.",
          confirmButtonColor: "#0078b9",
        });
        e.target.value = "";
        return;
      }

      // If valid, update state
      setForm((f) => ({ ...f, [name]: file }));
      if (name === "resume") setResumeName(file.name);
    }
  };

  // const isInValidEmail = (value) => {
  //   const emailPattern =
  //     /^[a-zA-Z0-9]+([._+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
  //   // Check if the value matches email pattern
  //   if (emailPattern.test(value)) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // };
  // Create Candidate Api Integration
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validation checks with SweetAlert
    if (!form.fullName.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Full Name",
        text: "Please enter the candidate's full name.",
      });
      return;
    }
    if (!form.email.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Email",
        text: "Please enter the candidate's email address.",
      });
      return;
    }
  //   if (isInValidEmail(form.email)) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Invalid Email",
  //       text: "Please enter valid email.",
  //     });
  //     return;
  //   }
  //   if (form.alternate_email.trim() && isInValidEmail(form.alternate_email.trim())) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Invalid Alternate Email",
  //       text: "Please enter valid alternate email.",
  //     });
  //     return; 
  // }
    if(form.email.trim().toLowerCase() === form.alternate_email.trim().toLowerCase()){
      Swal.fire({
        icon: "warning",
        title: "Duplicate Emails",
        text: "Email and Alternate Email cannot be the same.",
      });
      return;
    }
    if (!form.phone) {
      Swal.fire({
        icon: "warning",
        title: "Missing Phone Number",
        text: "Please enter the candidate's phone number.",
      });
      return;
    }
    if (form.phone.length !== 10) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Phone Number",
        text: "Please enter a valid 10-digit phone number.",
      });
      return;
    }
    if(!form.gender){
      Swal.fire({
        icon: "warning",
        title: "Missing Gender",
        text: "Please select the candidate's gender.",
      });
      return;
    }
    if(!form.dob){
      Swal.fire({
        icon: "warning",
        title: "Missing Date of Birth",
        text: "Please enter the candidate's date of birth.",
      });
      return;
    }

    const today = new Date().toISOString().split("T")[0];
    if (!form.dob || form.dob >= today) {
    Swal.fire({
    icon: "warning",
    title: "Invalid Date of Birth",
    text: "Date of Birth must be before today",
  });
  return;
}

    if (form.experience === "" || form.experience == null) {
      Swal.fire({
        icon: "warning",
        title: "Missing Total Experience",
        text: "Please enter Total experience.",
      });
      return;
    }
    if(String(form.experience).startsWith(".")){
      Swal.fire({
        icon: "warning",
        title: "Invalid Total Experience",
        text: "Total Experience should not start with a dot (.) character",
      });
      return;
    }
    if(!isFresher) {
      if(!form.relevant_exp){
        Swal.fire({
          icon: "warning",
          title: "Missing Relevant Experience",
          text: "Please enter relevant experience.",
        });
        return;
      }
      if(String(form.relevant_exp).startsWith(".")){
        Swal.fire({
          icon: "warning",
          title: "Invalid Relevant Experience",
          text: "Relevant experience should not start with a dot (.) character.",
        });
        return;
      }
      if(Number(form.relevant_exp) > Number(form.experience)){
        Swal.fire({
          icon: "warning",
          title: "Invalid Relevant Experience",
          text: "Relevant experience cannot be greater than total experience.",
        });
        return;
      }
      if(!form.designation){
        Swal.fire({
          icon: "warning",
          title: "Missing Current Designation",
          text: "Please enter the candidate's current designation.",
        });
        return;
      }
      if(!form.current_company){
        Swal.fire({
          icon: "warning",
          title: "Missing Current Company",
          text: "Please enter the candidate's current company.",
        });
        return;
      }
    }
    if(!form.current_location){
      Swal.fire({
        icon: "warning",
        title: "Missing Current Location",
        text: "Please select the candidate's current location.",
      });
      return;
    }
    if(!form.location || form.location.length === 0){
      Swal.fire({
        icon: "warning",
        title: "Missing Preferred Location",
        text: "Please select the candidate's preferred location.",
      });
      return;
    }
 
    if(!form.qualification_level){
      Swal.fire({
        icon: "warning",
        title: "Missing Education Qualification",
        text: "Please select candidate's highest educational qualification.",
      });
      return;
    }
    if(!form.education_qualification){
      Swal.fire({
        icon: "warning",
        title: "Missing Degree",
        text: "Please select Degree",
      });
      return;
    }


    // if (!form.present_ctc) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Missing Present CTC",
    //     text: "Please enter Present CTC.",
    //   });
    //   return;
    // }

    // if (!form.expected_cdc) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Missing Expected CTC",
    //     text: "Please enter Expected CTC.",
    //   });
    //   return;
    // }

    // if (Number(form.expected_cdc) <= Number(form.present_ctc)) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Invalid CTC",
    //     text: "Expected CTC must be greater than Present CTC.",
    //   });
    //   return;
    // }
    // Validate decimal places for CTC fields - must have exactly 2 decimal places if decimal is present


    const validateDecimalPlaces = (value) => {
      if (value === "" || value == null) return true;
      const valueStr = String(value);
      const decimalIndex = valueStr.indexOf('.');
      if (decimalIndex === -1) return true; // No decimal, that's okay
      const decimalPlaces = valueStr.length - decimalIndex - 1;
      return decimalPlaces === 2;
    };

    if (!isFresher) {
      if (
        form.present_ctc === "" ||
        isNaN(Number(form.present_ctc))
      ) {
        Swal.fire({
          icon: "warning",
          title: "Missing Present CTC",
          text: "Please enter a valid Present CTC.",
        });
        return;
      }
      if (form.present_ctc && !validateDecimalPlaces(form.present_ctc)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Present CTC Format",
          text: "Two digits must be entered after the decimal point (.)",
        });
        return;
      }
    }
      
      // Check if expected CTC exists and is valid
      if (
        form.expected_cdc === "" ||
        isNaN(Number(form.expected_cdc))
      ) {
        Swal.fire({
          icon: "warning",
          title: "Missing Expected CTC",
          text: "Please enter a valid Expected CTC.",
        });
        return;
      }
      if (form.expected_cdc && !validateDecimalPlaces(form.expected_cdc)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Expected CTC Format",
          text: "Two digits must be entered after the decimal point (.)",
        });
        return;
      }
      if(!isFresher){
      if(!form.notice_period){
      Swal.fire({
        icon: "warning",
        title: "Missing Notice Period",
        text:" Please enter the candidate's notice period.",
      });
      return;
      }
    }
    

    // Compare the values
    // const presentCTC = Number(form.present_ctc);
    // const expectedCTC = Number(form.expected_cdc);

    // if (expectedCTC <= presentCTC) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Invalid CTC",
    //     text: `Expected CTC must be greater than Present CTC`,
    //   });
    //   return;
    // }
    if(!form.any_offers_in_hand){
      Swal.fire({
        icon: "warning",
        title: "Missing Offers in Hand Information",
        text: "Please select if the candidate has any offers in hand.",
      });
      return;
    }
    // if(!form.willing_to_relocate){
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Missing Willingness to Relocate",
    //     text: "Please select if the candidate is willing to relocate.",
    //   });
    //   return;
    // }
  if (!form.communication_skills_rating) {
      Swal.fire({
        icon: "warning",
        title: "Missing Communication Skills Rating",
        text: "Please select a communication skills rating for the candidate.",
      });
      return;
    }

    if (!form.skills || form.skills.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Skills",
        text: "Please select at least one skill.",
      });
      return;
    }
    if (!form.resume) {
      Swal.fire({
        icon: "warning",
        title: "Missing Resume",
        text: "Please upload the candidate's resume.",
      });
      return;
    }
   
    const loginData = JSON.parse(localStorage.getItem("userData"));
    console.log("Login Data:", loginData);
    const createdBy =
      localStorage.getItem("user_id") ||
      loginData?.result_info?.user?.id ||
      null;

    console.log("Created By:", createdBy);
    const formData = new FormData();
    formData.append("candidate_name", form.fullName.trim());
    formData.append("email", form.email.trim().toLowerCase());
    formData.append("alternate_email",form.alternate_email.trim().toLowerCase());
    const cleanPhone = form.phone.replace(/\D/g, '').slice(-10);
    formData.append("phone", cleanPhone);
    formData.append("gender", form.gender);
    formData.append("country_field", "+91");
    formData.append("dob", form.dob);
     const experienceValue =
    form.experience === "" || form.experience == null
    ? ""
    : String(form.experience);

     formData.append("years_of_exp", experienceValue);
    const relevantExpValue = form.relevant_exp === "" || form.relevant_exp == null
  ? null
  : String(form.relevant_exp);
    const presentCTCValue = form.present_ctc === "" || form.present_ctc == null
      ? null
      : Number(form.present_ctc).toFixed(2);
    const expectedCTCValue = form.expected_cdc === "" || form.expected_cdc == null
      ? null
      : Number(form.expected_cdc).toFixed(2);
    formData.append("linkedin_url", form.linkedin.trim());
    formData.append(
      "location",
      Array.isArray(form.location) ? form.location.join(", ") : form.location
    );
    if (expectedCTCValue !== null) {
      formData.append("expected_cdc", expectedCTCValue);
    }
    formData.append("any_offers_in_hand", form.any_offers_in_hand);
    
    // When Total Experience = 0, leave related fields unset and let backend store null
    if (isFresher) {
      formData.append("designation", "");
      formData.append("current_company", "");
      if (form.notice_period) {
        formData.append("notice_period", form.notice_period);
      }
    } else {
      if (relevantExpValue !== null) {
        formData.append("relevant_exp", relevantExpValue);
      }
      formData.append("designation", form.designation.trim());
      formData.append("current_company", form.current_company.trim());
      if (presentCTCValue !== null) {
        formData.append("present_ctc", presentCTCValue);
      }
      formData.append("notice_period", form.notice_period);
    }
    
    formData.append("skills", form.skills.join(", "));
    formData.append("additional_notes", form.notes.trim());
    formData.append("current_location", form.current_location.trim());
    formData.append("communication_skills_rating", form.communication_skills_rating);
    formData.append("education_qualification", form.education_qualification);
    formData.append("qualification_level", form.qualification_level);;
    formData.append("willing_to_relocate", form.willing_to_relocate);
    formData.append("created_by", createdBy);
    formData.append("resume", form.resume);
    console.log("Form Data:", formData);

    try {
      const loaderGif = require("../assets/loader.gif");
      Swal.fire({
        html: '<img src="' + loaderGif + '" style="width: 50px" alt="loader">',
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });
      const res = await createCandidate(formData);
      Swal.close();
      if(res && res.result_code === 409){
        setError(res.message || "Candidate with this email already exists.");
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.message || "Candidate with this email already exists.",
        })
      }
      if(res && res.result_code === 404){
        setError(res.message || "Candidate with this phone number already exists.");
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.message || "Candidate with this phone number already exists.",
        })
      }
      if (res && res.status === "E") {
        setError(
          res.message || "Failed to create candidate. Please try again."
        );
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.message || "Failed to create candidate. Please try again.",
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "Candidate profile created successfully!",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          navigate("/candidates");
        });
      }
    } catch (e) {
      setError("Failed to create candidate. Please try again.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create candidate. Please try again.",
      });
    }
  };

  return (
    <div className="candidates-page">
      <div className="candidate-create-container">
        <h2 style={{ fontWeight: 600, fontSize: "1.3rem" }}>
          Create Candidate
        </h2>
        <p>Please provide accurate information.Fields marked *  are required</p>
        <div className="candidate-create-form">
          {/* Candidate Details */}
          <div className="candidate-section">
            <div className="candidate-section-title">1.Basic information</div>
            <div className="candidate-row">
              <div className="candidate-field">
                <label>Full Name *</label>
                <input
                  name="fullName"
                  value={form.fullName}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    // Don't allow if it doesn't start with a letter (but allow empty string)
                    if (value !== "" && !/^[a-zA-Z]/.test(value)) {
                      return; // Reject if doesn't start with letter
                    }
                    // Prevent consecutive spaces
                    if (/\s{2,}/.test(value)) {
                      return; // Reject if two or more spaces occur consecutively
                    }
                    const invalidPattern =
                      /<script*?>*?<\/script>|[<>\\{0-9}=:/""'']/i;
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, fullName: value });
                    }
                  }}
                  autoComplete="off"
                  required
                  placeholder="Enter full name"
                  className="custom-placeholder"
                />
              </div>
              <div className="candidate-field">
                <label>Email *</label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    //Prevent spaces
                    if(/\s/.test(value)){
                      return;
                    }
                    // Don't allow if it doesn't start with a letter or digit (but allow empty string)
                    if (value !== "" && !/^[a-zA-Z0-9]/.test(value)) {
                      return; // Reject if doesn't start with letter or digit
                    }
                    const emailPattern = /^[a-zA-Z0-9._%+-]+(@[a-zA-Z0-9.]*)?$/;
                    if (value && emailPattern.test(value)) {
                      setForm({ ...form, email: value });
                    } else if (!value) {
                      setForm({ ...form, email: "" });
                    }
                  }}
                  autoComplete="off"
                  required
                  placeholder="Enter email address"
                  className="custom-placeholder"
                />
              </div>
              <div className="candidate-field">
                <label>Alternate Email</label>
                <input
                  name="alternate_email"
                  type="email"
                  value={form.alternate_email}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    //Prevent spaces
                    if (/\s/.test(value)) {
                                    return; }
                    // Don't allow if it doesn't start with a letter or digit (but allow empty string)
                    if (value !== "" && !/^[a-zA-Z0-9]/.test(value)) {
                      return; // Reject if doesn't start with letter or digit
                    }
                    const emailPattern = /^[a-zA-Z0-9._%+-]+(@[a-zA-Z0-9.]*)?$/;
                    if (value && emailPattern.test(value)) {
                      setForm({ ...form, alternate_email: value });
                    } else if (!value) {
                      setForm({ ...form, alternate_email: "" });
                    }
                  }}
                  autoComplete="off"
                  placeholder="Enter alternate email address"
                  className="custom-placeholder"
                />
              </div>
              <div className="candidate-field">
                <label>Phone Number *</label>
                 <div
                   style={{
                          display: "flex",
                        alignItems: "center",
                       gap: "8px",
                                }}
                            >
                 <div style={{ border: "1px solid #ccc",
                               borderRadius: "4px",
                               padding: "8px 12px",
                               backgroundColor: "#f5f5f5",
                               fontSize: "16px",
                               fontWeight: "500",
                               minWidth: "60px",
                               textAlign: "center", }}>
                   +91</div>
                  <input
                    name="phone"
                    value={form.phone || ""}
                    onChange={(ev) => {
                      const value = ev.target.value;
                      const isNumbers = value.replace(/[^0-9]/g, ""); // Allow only digits
                      setForm({ ...form, phone: isNumbers});
                    }}
                    maxLength={10}
                    autoComplete="off"
                    required
                    placeholder="Enter 10-digit number"
                    className="custom-placeholder"
                    style={{ flex: 1 }}
                  />
              </div>
              </div>
            </div>
            </div>

            <div className="candidate-section">
              <div className="candidate-section-title">2.Personal information</div>
              <div className="candidate-row">
              <div className="candidate-field">
                <label>Gender *</label>
                <Select
                  name="gender"
                  options={genderOptions}
                  value={
                    form.gender
                      ? genderOptions.find((opt) => opt.value === form.gender)
                      : null
                  }
                  onChange={(selected) =>
                    setForm((f) => ({
                      ...f,
                      gender: selected ? selected.value : "",
                    }))
                  }
                  placeholder="Select Gender"
                  isSearchable={true}
                  classNamePrefix="react-select"
                  isClearable
                />
              </div>
              <div className="candidate-field">
                <label>Date of Birth *</label>
                <input
                  name="dob"
                  type="date"
                  min={"1900-01-01"}
                  max={new Date().toISOString().split("T")[0]}
                  value={form.dob}
                  onChange={(ev) => {
                                 const value = ev.target.value;
                                 setForm({ ...form, dob: value });
                      }}          
                  />
              </div>
            </div>
            </div>
            <div className="candidate-section">
              <div className="candidate-section-title">3.Professional Details</div>
              <div className="candidate-row">
               <div className="candidate-field">
                  <label>Total Experience *</label>
                    <input
                          name="experience"
                          type="text"
                          min="0"
                          max="100"
                          value={form.experience}
                          onChange={(e) => {
                                   const value = e.target.value;

                                  // Allow empty (so user can delete)
                                 if (value === "") {
                                 setForm({ ...form, experience: "" });
                                 return;
                                              }

                                 // Allow only numbers + optional one dot + max 2 decimals
                                 if (!/^\d{0,3}(\.\d{0,2})?$/.test(value)) return;

                                 // Convert to number for range validation
                                 const num = parseFloat(value);

                                if (num < 0 || num > 100) return;

                                 setForm({
                                           ...form,
                                           experience: value, 
                                              });

                                    }}
                                      onKeyDown={(e) => {
                                      if (
                                        e.key === "+" || 
                                        e.key === "-" ||
                                        e.key === "e" ||
                                        e.key === "E"
                                       
                                       
                                                ) {
                                        e.preventDefault();
                                                 }}}
                                   onWheel={(e) => e.target.blur()}
                                   autoComplete="off"
                                   placeholder="Enter total experience"
                                   className="custom-placeholder"
                               />
                    </div>
              <div className="candidate-field">
                <label>Relevant Experience {!isFresher && '*'}</label>
                       <input  
                          name="relevant_exp"
                          type="text"
                          disabled={isFresher}
                          step="0.1"
                          min="0"
                          max="100"
                          value={ isFresher ? "" : form.relevant_exp }
                          onChange={(e) => {
                           const value = e.target.value;

                                  // Allow empty (so user can delete)
                                 if (value === "") {
                                 setForm({ ...form, relevant_exp: "" });
                                 return;
                                              }

                                 // Allow only numbers + optional one dot + max 2 decimals
                                 if (!/^\d{0,3}(\.\d{0,2})?$/.test(value)) return;

                                 // Convert to number for range validation
                                 const num = parseFloat(value);

                                if (num < 0 || num > 100) return;

                                    
                                  setForm({
                                          ...form,
                                                relevant_exp: value,
                                            });
                                          }}
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "+" ||
                                        e.key === "-" ||
                                        e.key === "e" ||
                                        e.key === "E"
                                       
                                                ) {
                                        e.preventDefault();
                                                 }}}
                                   onWheel={(e) => e.target.blur()}
                                   autoComplete="off"
                                   placeholder="Enter relevant experience"
                                   className="custom-placeholder"
                                          
                      />
              </div>
              <div className="candidate-field">
                <label>Current Designation {!isFresher && '*'}</label>
                <input
                  name="designation"
                  disabled={isFresher}
                  value={ isFresher ? "" : form.designation }
                  onChange={(ev) => {
                    setForm({ ...form, designation: ev.target.value });
                  }}
                  autoComplete="off"
                  placeholder="Enter current designation"
                  className="custom-placeholder"
                />
              </div>
              <div className="candidate-field">
                <label>Current Company {!isFresher && '*'}</label>
                <input
                  name="current_company"
                  disabled={isFresher}
                  value={ isFresher ? "" : form.current_company }
                  onChange={(ev) => {
                    setForm({ ...form, current_company: ev.target.value });
                  }}
                  autoComplete="off"
                  placeholder="Enter current company"
                  className="custom-placeholder"
                />
              </div>
              </div>
              </div>
              <div className="candidate-row">
                <div className="candidate-field">
                <label>LinkedIn URL</label>
                <input
                  name="linkedin"
                  value={form.linkedin}
                  onChange={(ev) => {
                    const value = ev.target.value;
                    const invalidPattern =
                      /<script.*?>.*?<\/script>|[<>\\{}=""'']/i;
                    if (!invalidPattern.test(value)) {
                      setForm({ ...form, linkedin: value });
                    }
                  }}
                  autoComplete="off"
                  placeholder="https://www.linkedin.com/in/your-profile"
                  className="custom-placeholder"
                />
              </div>
              <div className="candidate-field">
                <label>Current Location *</label>
                <Select
                    name="current_location"
                    options={locationOptions}
                    value={
                          form.current_location
                          ? locationOptions.find((opt) => opt.value === form.current_location)
                          : null
                                 }
                          onChange={(selected) =>
                          setForm((f) => ({
                                           ...f,
                           current_location: selected ? selected.value : "",
                            }))
                      }
                          placeholder="Select Current Location"
                          isSearchable={true}
                          classNamePrefix="react-select"
                          isClearable
                     styles={{
                              control: (base) => ({
                                         ...base,
                               minHeight: 38,
                               borderRadius: 6,
                               fontSize: "1rem",
                               background: "#fff",
                               border: "1.5px solid #d1d5db",
                                     }),
                               menu: (base) => ({ ...base, zIndex: 20 }),
                            }}
                        />
                
              </div>
              <div className="candidate-field">
					    <label>Preferred Location *</label>
							<Select
								name="location"
								options={locationOptions}
								isMulti
								closeMenuOnSelect={false}
								hideSelectedOptions={false}
								components={{ Option: CheckboxOption }}
								value={
									Array.isArray(form.location)
										? locationOptions.filter((opt) =>
											form.location.includes(opt.value)
										)
										: []
								}
								onChange={(selected) =>
									setForm((f) => ({
										...f,
										location: selected
											? selected.map((opt) => opt.value)
											: [],
									}))
								}
								onKeyDown={(e) => {
									if (e.key === "Enter") {
										e.preventDefault();
										e.stopPropagation();
									}
								}}
								placeholder="Select Preferred Location"
								isSearchable={true}
								classNamePrefix="react-select"
								isClearable

								/* Prevent dropdown opening when clicking/focusing */
								openMenuOnClick={false}
								openMenuOnFocus={false}

								styles={{
									control: (base) => ({
										...base,
										minHeight: 38,
										maxHeight: 80,
										borderRadius: 6,
										fontSize: "1rem",
										background: "#fff",
										border: "1.5px solid #d1d5db",
										overflow: "hidden",
									}),

									valueContainer: (base) => ({
										...base,
										maxHeight: 70,
										overflowY: "auto",
										overflowX: "hidden",
										flexWrap: "wrap",
										alignContent: "flex-start",
									}),

									menu: (base) => ({
										...base,
										zIndex: 20,
									}),

									option: (base, state) => ({
										...base,
										backgroundColor: state.isSelected
											? "#f3f4f6"
											: state.isFocused
												? "#f8fafc"
												: "#fff",
										color: "#111827",
									}),

									multiValue: (base) => ({
										...base,
										backgroundColor: "#e2e8f0",
									}),

									multiValueLabel: (base) => ({
										...base,
										color: "#111827",
									}),
								}}
							/>
						</div>
            </div>
            <div className="candidate-section">
              <div className="candidate-section-title">4.Educational Qualification</div>
              <div className="candidate-row">
         <div className="candidate-field education-field" style={{ flex: 2 }}>
    
        <label className="edu-main-label">Highest Qualification *</label>
          {/* <p className="edu-subtitle">Select your highest qualification</p> */}

       {/* Radio Options */}
      <div className="edu-options">
      {["Bachelors", "Masters", "Others"].map((item) => (
        <label
          key={item}
          className={`edu-card ${
            form.qualification_level === item ? "active" : ""
          }`}
        >
          <input
            type="radio"
            name="qualification_level"
            value={item}
            checked={form.qualification_level === item}
          onChange={(e) => {
               const value = e.target.value;
               setForm((prev) => ({
               ...prev,
               qualification_level: value,
education_qualification: "", // Reset degree when qualification level changes
              }));                  
           }}
          />

          <span className="radio-circle"></span>
          <span className="edu-text">{item}</span>
        </label>
      ))}
    </div>

    {/* Input Field */}
  {form.qualification_level && (
  <div className="edu-input-group">
    <label>Degree *</label>

    <Select
     options={degreeOptions.filter(
    (opt) =>
      opt.qualification_level === form.qualification_level
       )}

      value={
        degreeOptions.find  (
          (opt) => opt.value === form.education_qualification
        ) || null
      }
      onChange={(selected) =>
        setForm((prev) => ({
          ...prev,
          education_qualification: selected?.value || "",
        }))
      }
      placeholder="Select Degree"
      isSearchable
      isClearable
      classNamePrefix="react-select"
    />
  </div>
)}

</div>
  </div>
  </div>
    <div className="candidate-section">
      <div className="candidate-section-title">5. Compensation & Availability</div>
      <div className="candidate-row">
        <div className="candidate-field">
          <label>Present CTC (in lakhs) {!isFresher && '*'}</label>
          <input
            name="present_ctc"
            type="text"
            disabled={isFresher}
            min="0"
            max="999"
            value={isFresher ? "" : form.present_ctc}
           onChange={(ev) => {
           const value = ev.target.value;

           // Allow empty string
          if (value === "") {
          setForm({ ...form, present_ctc: "" });
           return;
               }

          // Allow only numbers with optional decimal and max 2 digits after decimal
             if (!/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
             return;
                  }

          // Prevent values greater than 999
          if (Number(value) > 999) {
          return;
                  }

            setForm({ ...form, present_ctc: value });}}
            onKeyDown={(e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault();
              }
            }}
            placeholder="Enter present ctc (e.g., 10.50)"
            className="custom-placeholder"
            autoComplete="off"
          />
        </div>
        <div className="candidate-field">
          <label>Expected CTC (in lakhs) *</label>
          <input
            name="expected_cdc"
            type="text"
            min="0"
            max="999"
            value={form.expected_cdc}
            onChange={(ev) => {
            const value = ev.target.value;

           // Allow empty string
          if (value === "") {
          setForm({ ...form, expected_cdc: "" });
           return;
               }

          // Allow only numbers with optional decimal and max 2 digits after decimal
             if (!/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
             return;
                  }

          // Prevent values greater than 999
          if (Number(value) > 999) {
          return;
                  }

            setForm({ ...form, expected_cdc: value });}}
            onKeyDown={(e) => {
              if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault();
              }
            }}
            placeholder="Enter expected ctc (e.g., 12.50)"
            className="custom-placeholder"
            autoComplete="off"
          />
        </div>
        <div className="candidate-field">
          <label>Notice Period (in days) {!isFresher && '*'}</label>
          <input
            name="notice_period"
            type="text"
            min="0"
            disabled={isFresher}
            value={isFresher ? "" : form.notice_period}
             onChange={(ev) => {
                    const value = ev.target.value;

                    const isValid = value === '' || /^\d[0-9]*$/.test(value);

                    if (isValid) {
                      setForm({ ...form, notice_period: value });
                    }
                  }}
                  onKeyDown={(e) => {
                                      if (
                                        e.key === "-" ||
                                        e.key === "+" || 
                                        e.key === "e" ||
                                        e.key === "E"
                                       ) {
                                        e.preventDefault();
                                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                      e.preventDefault();}}}}
            autoComplete="off"
            placeholder="Enter notice period"
            className="custom-placeholder"
          />
        </div>
        </div>
        <div className="candidate-row">
          <div className="candidate-field">
          <label>Any Offers in Hand *</label>
          <div className="any_offers_in_hand">
            {[" Yes", " No"].map((item) => (
              <label
                key={item}
                className={`radio-label ${form.any_offers_in_hand === item ? 'active' : ''}`}
              >
                <input
                  type="radio"
                  name="any_offers_in_hand"
                  value={item}
                  checked={form.any_offers_in_hand === item}
                  onChange={() => setForm({ ...form, any_offers_in_hand: item })}
                />
                {item}
              </label>
            ))}

          </div>
          </div>
          <div className="candidate-field">
          <label>Willing to Relocate ? </label>
          <div style={{ display: "flex", gap: "13px" }}>
            {[{ label: " Yes", value: " Yes" }, { label: " No", value: " No" }].map((item) => (
              <label
                key={item.label}
                className={`radio-label ${form.willing_to_relocate === item.value ? 'active' : ''}`}
              >
                <input
                  type="radio"
                  name="willing_to_relocate"
                  value={item.value}
                  checked={form.willing_to_relocate === item.value}
                  onChange={() => setForm({ ...form, willing_to_relocate: item.value })}

                />
                {item.label}
              </label>
            ))}
          </div>
        </div>
          </div>
          <div className="candidate-section">
        <div className="candidate-section-title">6. Recruiter/Interview Feedback(Internal Use Only)</div>
        <div className="candidate-row">
          <div className="candidate-field">
                  <label>Communication Skills Rating *</label>
                    <div className="star-rating">
                      {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        className={`star ${
                        form.communication_skills_rating >= star ? "active" : ""
                          }`}
                         onClick={() =>
                         setForm((f) => ({
                           ...f,
                        communication_skills_rating: star,
                         }))
                         }
                        >
                           ★
                   </span>
                      ))}
                 </div>
                  <div className="rating-label">
                         {
                            {
                             1: "Poor",
                             2: "Below Average",
                             3: "Average",
                             4: "Good",
                             5: "Excellent",
                      }[form.communication_skills_rating] || ""
                    }
               </div>
              </div>
           </div>
         </div>
      <div className="candidate-section">
        <div className="candidate-section-title">7. Skills</div>
            {/* Skills */}
          <div className="candidate-row">
            <div className="candidate-field">
              <label>Professional Skills *</label>
             <Select
              isMulti
              options={skillsOptions}
              value={form.skills.map((skill) => skillsOptions.find((opt) => opt.value === skill)).filter(Boolean)}
              onChange={(selected) =>
                setForm((f) => ({
                  ...f,
                  skills: selected ? selected.map((opt) => opt.value) : [],
                }))
              }
              placeholder="Select skills"
              isSearchable={true}
              classNamePrefix="react-select"
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: 38,
                  borderRadius: 6,
                  fontSize: "1rem",
                  background: "#fff",
                  border: "1.5px solid #d1d5db",
                  marginBottom: "1.2rem",
                }),
                menu: (base) => ({ ...base, zIndex: 20 }),
              }}
            />
          </div>
          </div>
          </div>
          <div className="candidate-section">
              <div className="candidate-section-title">8. Documents</div>
          {/* Documents & Profile */}
            <div className="candidate-row">
              <div className="candidate-field" style={{ flex: 2 }}>
                <label>Upload Resume *</label>
                <div className="file-upload-box">
                  <input
                    type="file"
                    name="resume"
                    accept=".pdf,.doc,.docx"
                    style={{ display: "none" }}
                    id="resume-upload"
                    onChange={handleFileChange}
                    required
                  />
                  <label htmlFor="resume-upload" className="file-upload-label">
                    <span className="file-upload-icon">&#8682;</span>
                    {resumeName ? (
                      resumeName
                    ) : (
                      <span>
                        Drop resume here or{" "}
                        <span className="file-upload-link">browse</span>
                      </span>
                    )}
                    <div className="file-upload-desc">
                      PDF, DOC, DOCX up to 10MB
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="candidate-section">
            <div className="candidate-section-title">9. Additional Notes</div>
            <textarea
              className="candidate-notes custom-placeholder"
              name="notes"
              value={form.notes}
              onChange={(ev) => {
                const value = ev.target.value;
                const invalidPattern =
                  /<script.*?>.*?<\/script>|[<>\\{}=:/""'']/i;
                if (!invalidPattern.test(value)) {
                  setForm({ ...form, notes: value });
                }
              }}
              placeholder="Add any additional remarks or notes about the candidate"
              rows="2"
              autoComplete="off"
            ></textarea>
          </div>
          {error && (
            <div style={{ color: "#e53e3e", marginBottom: 12 }}>{error}</div>
          )}
          <div className="candidate-actions">
            <button
              className="cancel-btn"
              type="button"
              onClick={() => navigate("/candidates")}
            >
              Cancel
            </button>
            <button className="save-btn" type="button" onClick={handleSubmit}>
              Create
            </button>
          </div>
        </div>
     </div>
      </div>
    </div>
  );
}
export default CreateCandidate;
